import { UserPermissions } from './user.permissions';
import { UserRoles } from './user.roles';

export const userMappings = {
  [UserPermissions.ADD_CONNECTION]: [UserRoles.CONNECTION_EDITOR],
  [UserPermissions.DELETE_CONNECTION]: [UserRoles.CONNECTION_EDITOR],
  [UserPermissions.ACCESS_LEGACY_APP]: [UserRoles.LEGACY_APP_USER],
};
